import React, { FunctionComponent, useEffect, useState } from 'react';
import { auth as firebaseAuth } from '../config/firebase';
import logging from '../config/logging';
import { Spinner } from 'reactstrap';
import { User } from 'firebase/auth';

type AuthContextProvider = {
  auth: User | null
};

export const AuthContext = React.createContext<AuthContextProvider>({ auth: null });

type AuthProviderProps = {
  children: React.ReactNode
}

const AuthProvider: FunctionComponent<AuthProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [auth, setAuth] = useState<User | null>(null);

  useEffect(() => {
    firebaseAuth.onAuthStateChanged((user: User | null) => {
      if (user)
      {
        logging.info('User detected.');
        console.log('User data: ', user);
      }
      else
      {
        logging.info('No user detected');
      }

      setAuth(user);
      setLoading(false);
    })
  }, []);

  if (loading)
    return <Spinner color="info" />

  return (
    <AuthContext.Provider value={{ auth }} >
      { children }
    </AuthContext.Provider>
  );
}

export default AuthProvider;
